module.exports = __webpack_public_path__ + "img/mark-icon-active.9a3841c8.png";